import pubsub from '@/scripts/pubsub/rhm-pubsub.js';
console.log("banana", pubsub.subscribe);